import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LoadingOverlay from '../../components/others/LoadingOverlay';
import { loadDataLogin } from '../../redux/actions/auth';

const IMPERSONATE_STORAGE_PREFIX = 'impersonate_session_';

export const buildImpersonateStorageKey = () =>
    `${IMPERSONATE_STORAGE_PREFIX}${Date.now()}_${Math.random().toString(36).slice(2)}`;

export const ImpersonateScreen = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [error, setError] = useState(null);

    useEffect(() => {
        const key = searchParams.get('key');
        if (!key || !key.startsWith(IMPERSONATE_STORAGE_PREFIX)) {
            setError('Sesión de suplantar inválida');
            return;
        }

        try {
            const raw = localStorage.getItem(key);
            localStorage.removeItem(key);

            if (!raw) {
                setError('La sesión de suplantar expiró o no está disponible');
                return;
            }

            const userData = JSON.parse(raw);
            if (!userData?.session?.token) {
                setError('Datos de sesión incompletos');
                return;
            }

            sessionStorage.setItem('user', JSON.stringify(userData));
            dispatch(loadDataLogin(userData));
            navigate('/home', { replace: true });
        } catch (err) {
            console.error('Error al cargar sesión de suplantar', err);
            setError('No fue posible iniciar la sesión suplantar');
        }
    }, [dispatch, navigate, searchParams]);

    if (error) {
        return (
            <div style={{ padding: 24, textAlign: 'center' }}>
                {error}
            </div>
        );
    }

    return <LoadingOverlay isOpen text="Iniciando sesión..." />;
};
